import { ListItemButton } from "@mui/material";

import {
  WorkingAreaDescription,
  WorkingAreaInfo,
  WorkingAreaLabel,
  WorkingAreaTitle,
} from "./styles.styled";

export interface AreaDef {
  label: string;
  title: string;
  desc: string;
  color: string;
  borderColor?: string;
}

interface WorkingAreaItemContentProps {
  area: AreaDef;
  areaIndex: number;
  isOpened: boolean;
  openTab: () => void;
  isVerticalAccordion?: boolean;
}

export const WorkingAreaItemContent = ({
  area: { label, title, desc },
  areaIndex,
  isOpened,
  openTab,
  isVerticalAccordion,
}: WorkingAreaItemContentProps) => {
  const iconAsLabel = isVerticalAccordion && areaIndex === 0;
  const removeTitle = isVerticalAccordion && areaIndex !== 0;

  return (
    <>
      <ListItemButton onClick={openTab} disabled={isOpened}>
        {!iconAsLabel && (
          <WorkingAreaLabel primary={label} isOpened={isOpened} />
        )}
      </ListItemButton>

      <WorkingAreaInfo>
        {!removeTitle && <WorkingAreaTitle>{title}</WorkingAreaTitle>}

        <WorkingAreaDescription>{desc}</WorkingAreaDescription>
      </WorkingAreaInfo>
    </>
  );
};
